import { createStore, applyMiddleware, Store } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

/**Types State dos modulos */
import { StatusAppState } from "../modulos/root/root.model"
import { UsuarioState } from "../modulos/usuario/usuario.model"
import { ProcedimentoState } from "../modulos/procedimento/procedimento.model"
import { PacienteState } from "../modulos/paciente/paciente.model"
import { AtendimentoState } from "../modulos/atendimento/atendimento.model"


/**State geral para exibir os types na view */
export interface ApplicationState {
    statusAppState:StatusAppState,
    usuarioState:UsuarioState,
    procedimentoState:ProcedimentoState,
    pacienteState:PacienteState,
    atendimentoState:AtendimentoState

}

const sagaMiddleware = createSagaMiddleware()

const store:Store <ApplicationState> = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;
 